<div class="chart-wrapper">
  <ng-container *ngTemplateOutlet="chartContent"></ng-container>
</div>
<ng-template #chartContent>
  <div class="header-content">
    <div class="title-content">
      <h6 [matTooltip]="data.name.length > 50 ? data.name : null"
        matTooltipHideDelay="300"
      >{{ data.name }}</h6>
      <p>{{ data.unit }}</p>
    </div>
  </div>

  <div>
    @if (!data.stages.length) {
      <app-empty-chart [description]="emptyChart.description"
      [title]="emptyChart.title"></app-empty-chart>
    }

    @if (data.stages.length && chartOptions) {
      <div #chartContainer class="chart-content">
        <highcharts-chart
          [Highcharts]="highcharts"
          [callbackFunction]="chartCallback"
          [oneToOne]="true"
          [options]="chartOptions"
          class="chart-1">
        </highcharts-chart>
      </div>
    }
  </div>
</ng-template>
